import { LeftOutlined, DownOutlined } from '@ant-design/icons';
import {
    Menu,
    Dropdown,
    Checkbox,
    Button,
    Divider,
    Radio,
    Spin,
    Modal,
    message,
} from 'antd';
import {
    getAlbumList,
    getSelectParamsList,
    getVirtualRoomVersion,
    getVirtualRoomCoordinate,
    createVirtualRoom,
    getVirtualRoomAlbumList,
    editVirtualRoom,
    createShare,
} from '@/api/hdd/album';
import { useEffect } from 'react';
import { useRouterTarget } from '&/utils/customHooks';
import Empty from '@/components/PhotoAlbumItem/Empty';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './virtualHouseCreate.scss';

export default function VirtualHouseCerate(props) {
    const schemeId =
        new URLSearchParams(window.location.search).get('schemeId') || 1098;

    const type = new URLSearchParams(window.location.search).get('type');

    const renderId = new URLSearchParams(window.location.search).get('id');

    const createdRenderId = useRef();

    usePreventDefault();

    const [albumList, setAlbumList] = useState([]);

    const [resolution, setResolution] = useState([]);

    const [space, setSpace] = useState([]);

    const [resolutionItem, setResolutionItem] = useState({
        id: 'all',
        name: '全部分辨率',
    });

    const [spaceItem, setSpaceItem] = useState({ id: 'all', name: '全部空间' });

    const [detail, setDetail] = useState({});

    const hDocId = useRef();

    const getSelectParams = () => {
        let params = { hDocId: schemeId, renderType: 1, status: 2 };

        getSelectParamsList(params).then(res => {
            let resolutionList = res.data.list.resolution?.map(v => ({
                id: v.resolution,
                name: v.resolution,
            }));
            let spaceList = res.data.list.roomType?.map(v => ({
                id: v.roomType,
                name: v.roomType,
            }));
            resolutionList.unshift({ id: 'all', name: '全部分辨率' });
            spaceList.unshift({ id: 'all', name: '全部空间' });
            setResolution(resolutionList);
            setSpace(spaceList);
        });
    };

    useEffect(() => {
        getSelectParams();
        if (type === 'edit') {
            getVirtualRoomAlbumList({ hDocId: schemeId, renderId }).then(
                res => {
                    console.log('res', res);
                    const detail = res.data.list[0];
                    setAllSelectList(detail.renderIdList.split(','));
                    setValue(detail.first);
                    setDetail(detail);
                    hDocId.current = detail?.hDocId;
                }
            );
        } else {
            getVirtualRoomVersion({ hDocId: schemeId }).then(res => {
                console.log('res', res);
                hDocId.current = res.data?.list[0]?.hDocId;
                setDetail(res.data?.list[0]);
            });
        }
    }, []);

    const [allPanoramaList, setAllPanoramaList] = useState([]);

    const isFirst = React.useRef(true);

    const [loading, setLoading] = useState(false);

    const [allSelectList, setAllSelectList] = useState([]);

    const [locationList, setLocationList] = useState([]);

    useEffect(() => {
        setLoading(true);
        getAlbumList({
            hDocId: schemeId,
            renderType: 1,
            status: 2,
            resolution:
                resolutionItem.id !== 'all' ? resolutionItem.id : undefined,
            roomType: spaceItem.id !== 'all' ? spaceItem.id : undefined,
        })
            .then(res => {
                let list = res.data.list;
                if (isFirst.current) {
                    setAllPanoramaList(list);

                    isFirst.current = false;

                    if (!list.length) {
                        return;
                    }

                    if (type !== 'edit') {
                        setAllSelectList([list[0]?.id]);
                    }

                    getVirtualRoomCoordinate({
                        hDocId: schemeId,
                        renderIdList: list.map(v => v.id),
                    }).then(res => {
                        setLocationList(res.data.space);
                    });
                }

                setAlbumList(list);

                if (!value && type !== 'edit') {
                    setValue(list[0]?.id);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    }, [resolutionItem, spaceItem]);

    const onResolutionClick = ({ item, key }) => {
        const selected = resolution.find(item => item.id === key);
        setResolutionItem(selected);
    };
    const onSpaceClick = ({ item, key }) => {
        const selected = space.find(item => item.id === key);
        setSpaceItem(selected);
    };

    const resolutionMenu = (
        <Menu
            onClick={onResolutionClick}
            defaultSelectedKeys={'0'}
            selectedKeys={resolutionItem?.id}>
            {resolution.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const spaceMenu = (
        <Menu onClick={onSpaceClick} selectedKeys={spaceItem?.id}>
            {space.map(item => (
                <Menu.Item key={item.id}>{item.name}</Menu.Item>
            ))}
        </Menu>
    );

    const allChangeFn = checked => {
        setAllSelectList(prev => {
            let next;
            if (checked) {
                next = [...new Set(prev.concat(albumList.map(v => v.id)))];
            } else {
                next = prev.filter(v => !albumList.map(v => v.id).includes(v));
            }
            return next;
        });
    };

    const onAllChange = e => {
        if (e.target.checked) {
            allChangeFn(true);
            if (!value) {
                setValue(albumList[0].id);
            }
        } else {
            allChangeFn(false);
            if (albumList.some(v => v.id === value)) {
                setValue('');
            }
        }
    };

    const [value, setValue] = useState('');

    const onStartChange = e => {
        setValue(e.target.value);
        onCheckChange({ target: { checked: true } }, e.target.value);
    };

    const onCheckChange = (e, id) => {
        if (!value && e.target.checked) {
            setValue(id);
        }

        if (e.target.checked) {
            setAllSelectList(prev => {
                let next = [...prev];
                if (!next.includes(id)) {
                    next.push(id);
                }
                return next;
            });
        } else {
            setAllSelectList(prev => {
                let next = [...prev];
                next = next.filter(v => v !== id);
                if (id === value) {
                    setValue(
                        next.find(v => albumList.map(v => v.id).includes(v))
                    );
                }
                return next;
            });
        }
    };

    const [allSelect, setAllSelect] = useState(false);

    useEffect(() => {
        if (albumList.every(v => allSelectList.includes(v.id))) {
            setAllSelect(true);
        } else {
            setAllSelect(false);
        }
    }, [albumList, allSelectList]);

    const onGoBack = () => {
        if (type === 'edit') {
            targetPage({
                pathname: '/hdd/photoAlbum',
                search: {
                    schemeId,
                    tab: 'virtualHouseTour',
                },
            });
            return;
        }
        props.history.goBack();
    };

    const onCreatePanorama = () => {
        console.log('创建全景图');
        try {
            window.external.DispatchFun('Atlas', 'CratePanoramaImage', '');
        } catch (e) {}
    };

    const sendEventToHDD = () => {
        console.log('点击创建全屋漫游按钮');
        try {
            window.external.DispatchFun('Atlas', 'OnClickCratePanoramaBtn', '');
        } catch (e) {}
    };

    const onCreateVirtual = () => {
        console.log('生成全屋漫游图');
        let apiName, isEdit;
        if (type === 'edit') {
            apiName = editVirtualRoom;
            isEdit = true;
        } else {
            apiName = createVirtualRoom;
            isEdit = false;
            sendEventToHDD();
        }
        apiName({
            hDocId: hDocId.current,
            renderIdList: allSelectList.join(','),
            first: value,
            renderId: renderId ? renderId : undefined,
        }).then(res => {
            console.log('res', res);
            if (!isEdit) {
                setOpen(true);
                console.log('renderId', res.data[0].id);
                createdRenderId.current = res.data[0].id;
            } else {
                message.success('保存成功');
                onGoBack();
            }
        });
    };

    const [open, setOpen] = useState(false);

    const handleCancel = () => {
        setOpen(false);
    };

    const targetPage = useRouterTarget();

    const handleEditNow = () => {
        setOpen(false);
        console.log('renderId', renderId);
        targetPage({
            pathname: '/hdd/panoramaEdit',
            search: {
                id: createdRenderId.current,
                schemeId,
                type: 'panoramaVrRoom',
            },
        });
    };

    const handleBrowserLook = () => {
        setOpen(false);
        createShare({
            renderId: createdRenderId.current,
            type: 2,
        }).then(res => {
            if (!res.data) return;
            let url = `${window.location.host}/hdd/panoramaShare?shareCode=${
                res.data.shareCode
            }&panorama=${1}`;
            console.log('url', url);
            try {
                window.external.DispatchFun('Atlas', 'OpenBrowser', url);
            } catch (error) {
                Promise.reject(error);
            }
        });
    };

    const [hoverId, setHoverId] = useState();

    const handleEnterLocation = id => {
        console.log('id', id);
        setHoverId(id);
    };

    const handleLeaveLocation = () => {
        setHoverId(null);
    };

    return (
        <Spin spinning={loading}>
            <div className="virtual-house-create">
                <div className="header">
                    <div onClick={onGoBack}>
                        <LeftOutlined /> 返回图册
                    </div>
                    <div className="title">创建全屋漫游图</div>
                </div>
                {!!allPanoramaList.length && (
                    <div className="virtual-house-content">
                        <div className="left-house-preview">
                            <div className="header-info">
                                <div className="panorama-total">
                                    共{allPanoramaList.length}张全景图
                                    <Divider type="vertical" />
                                    已选
                                    {allSelectList.length}张
                                </div>
                                <div className="location-tip">
                                    <div className="location-item">
                                        <img
                                            src={
                                                require('@/assets/img/hdd/location-2.png')
                                                    .default
                                            }></img>
                                        <div>起点</div>
                                    </div>
                                    <div className="location-item">
                                        <img
                                            src={
                                                require('@/assets/img/hdd/location-3.png')
                                                    .default
                                            }></img>
                                        <div>选中</div>
                                    </div>
                                    <div className="location-item">
                                        <img
                                            src={
                                                require('@/assets/img/hdd/location-1.png')
                                                    .default
                                            }></img>
                                        <div>未选中</div>
                                    </div>
                                </div>
                            </div>
                            <div className="img-wrap">
                                <div className="inter-wrap">
                                    <img
                                        src={
                                            detail?.cacheThumbnailHigh ||
                                            detail?.thumbnailHigh
                                        }></img>
                                    {allPanoramaList.map(v => (
                                        <div
                                            className={`tip ${
                                                v.id === value ? 'start' : ''
                                            } ${
                                                allSelectList.includes(v.id)
                                                    ? 'selected'
                                                    : ''
                                            }`}
                                            key={v.id}
                                            onClick={() =>
                                                onCheckChange(
                                                    {
                                                        target: {
                                                            checked:
                                                                !allSelectList.includes(
                                                                    v.id
                                                                ),
                                                        },
                                                    },
                                                    v.id
                                                )
                                            }
                                            onMouseEnter={() =>
                                                handleEnterLocation(v.id)
                                            }
                                            onMouseLeave={handleLeaveLocation}
                                            style={{
                                                left: locationList?.[v.id]?.x,
                                                top: locationList?.[v.id]?.y,
                                            }}></div>
                                    ))}
                                </div>
                            </div>
                            <div className="btn-wrap">
                                <Button
                                    type="primary"
                                    className="btn"
                                    disabled={!value || !allSelectList?.length}
                                    onClick={onCreateVirtual}>
                                    {type === 'edit'
                                        ? '完成增删'
                                        : '生成全屋漫游图'}
                                </Button>
                            </div>
                        </div>
                        <div className="right-select">
                            <div className="select-operate">
                                <div className="dropdown-item">
                                    <Dropdown
                                        overlay={resolutionMenu}
                                        overlayClassName="hdd-dropdown-menu"
                                        trigger={['click']}>
                                        <span className="resolution">
                                            {resolutionItem.name}
                                            <DownOutlined />
                                        </span>
                                    </Dropdown>
                                    <Dropdown
                                        overlay={spaceMenu}
                                        overlayClassName="hdd-dropdown-menu"
                                        trigger={['click']}>
                                        <span className="space">
                                            {spaceItem.name}
                                            <DownOutlined />
                                        </span>
                                    </Dropdown>
                                </div>
                                <div>
                                    <Checkbox
                                        onChange={onAllChange}
                                        checked={allSelect}>
                                        全选
                                    </Checkbox>
                                </div>
                            </div>
                            <div className="room-wrap">
                                <Radio.Group
                                    onChange={onStartChange}
                                    value={value}>
                                    {albumList.map(item => (
                                        <div
                                            className={`room-item ${
                                                allSelectList.includes(item.id)
                                                    ? 'active'
                                                    : ''
                                            }  ${
                                                item.id === hoverId
                                                    ? 'hover'
                                                    : ''
                                            }`}
                                            key={item.id}>
                                            <div className={`room-img`}>
                                                <img
                                                    src={
                                                        item.coverImageUrl
                                                    }></img>
                                                <div className="room-img-mask">
                                                    <div className="room-img-mask__tip">
                                                        {item.resolution}
                                                    </div>
                                                    <Checkbox
                                                        className="room-img-mask__checkbox"
                                                        style={{
                                                            display:
                                                                allSelectList.includes(
                                                                    item.id
                                                                )
                                                                    ? 'flex'
                                                                    : '',
                                                        }}
                                                        checked={allSelectList.includes(
                                                            item.id
                                                        )}
                                                        onChange={e =>
                                                            onCheckChange(
                                                                e,
                                                                item.id
                                                            )
                                                        }></Checkbox>
                                                </div>
                                            </div>
                                            <div className="room-info">
                                                <div className="room-info__title">
                                                    {item.title}
                                                </div>
                                                <div className="room-info__resolution">
                                                    <Radio value={item.id}>
                                                        设为起点
                                                    </Radio>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Radio.Group>
                            </div>
                        </div>
                    </div>
                )}
                {!allPanoramaList.length && (
                    <div className="empty-wrap">
                        <Empty
                            tip="当前没有可选的全景图，请先创建全景图"
                            btnWord="创建全景图"
                            handleCreate={onCreatePanorama}></Empty>
                    </div>
                )}
                <Modal
                    title="全屋漫游图已生成"
                    visible={open}
                    width={480}
                    wrapClassName="virtual-house-modal"
                    onCancel={handleCancel}
                    footer={[
                        <Button key="edit" onClick={handleEditNow}>
                            立即编辑
                        </Button>,
                        <Button key="share" onClick={handleBrowserLook}>
                            新窗口查看
                        </Button>,
                    ]}>
                    <img
                        className="img"
                        src={
                            allPanoramaList.find(v => v.id === value)
                                ?.coverImageUrl
                        }></img>
                </Modal>
            </div>
        </Spin>
    );
}
